import {
  useCompanyInstantPaymentLimitsQuery,
  useUpdateInstantPaymentAmountLimits,
  useUpdateInstantPaymentDailyLimits,
} from './instantPaymentLimits.queries';

export const useFetchCompanyInstantPaymentLimits = ({
  isEnabled = true,
}: {
  isEnabled?: boolean;
} = {}) => {
  const { mutateAsync: updateInstantPaymentDailyLimits } =
    useUpdateInstantPaymentDailyLimits();
  const { mutateAsync: updateInstantPaymentAmountLimits } =
    useUpdateInstantPaymentAmountLimits();

  const result = useCompanyInstantPaymentLimitsQuery({ isEnabled });

  const disableInstantPaymentAmountLimits = () => {
    return updateInstantPaymentAmountLimits({
      amountLimit: 0,
      disableDailyLimit: true,
    });
  };

  const disableInstantPaymentDailyLimits = () => {
    return updateInstantPaymentDailyLimits({ dailyLimit: null });
  };

  const enableInstantPaymentAmountLimits = () => {
    if (!result.data?.maxAmountLimit) {
      return;
    }
    return updateInstantPaymentAmountLimits({
      amountLimit: result.data?.maxAmountLimit,
    });
  };

  const enableInstantPaymentDailyLimits = () => {
    if (!result.data?.maxDailyLimit) {
      return;
    }
    return updateInstantPaymentDailyLimits({
      dailyLimit: result.data?.maxDailyLimit,
    });
  };

  // Amount limit is considered disabled for company only if it is 0
  const isAmountLimitEnabled =
    result.data == null ? true : result.data.amountLimit > 0;

  const isDailyLimitEnabled = !!(
    result.data?.dailyLimit && result.data.dailyLimit > 0
  );

  return {
    ...result,
    isAmountLimitEnabled,
    isDailyLimitEnabled,
    enableInstantPaymentAmountLimits,
    enableInstantPaymentDailyLimits,
    disableInstantPaymentAmountLimits,
    disableInstantPaymentDailyLimits,
    updateInstantPaymentAmountLimits,
    updateInstantPaymentDailyLimits,
  };
};
